export default "__VITE_ASSET__4zZCZDas__"